import { render, staticRenderFns } from "./QueueButtons.vue?vue&type=template&id=8c1cbde2&scoped=true&"
import script from "./QueueButtons.vue?vue&type=script&lang=js&"
export * from "./QueueButtons.vue?vue&type=script&lang=js&"
import style0 from "../Style/analysis-selection.scss?vue&type=style&index=0&id=8c1cbde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1cbde2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c1cbde2')) {
      api.createRecord('8c1cbde2', component.options)
    } else {
      api.reload('8c1cbde2', component.options)
    }
    module.hot.accept("./QueueButtons.vue?vue&type=template&id=8c1cbde2&scoped=true&", function () {
      api.rerender('8c1cbde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Customers/Mangl/Modules/AnalysisSelection/Components/QueueButtons.vue"
export default component.exports